<template>
  <el-dialog :title="$t('message.batchDispatchServiceOperator')" :visible.sync="dialogVisible" width="520px"
    :close-on-click-modal="false" :close-on-press-escape="!submitting" :show-close="!submitting" center>
    <div class="admin-select">
      <span>{{ $t('message.personnelSelection') }}：</span>
      <el-select v-model="adminId" :placeholder="$t('message.serviceOperator')" :disabled="submitting"
        filterable clearable>
        <el-option v-for="item in adminList" :key="item.id" :label="item.realname" :value="item.id" />
      </el-select>
    </div>

    <!-- 批量接口按服务单逐个调用，执行期间展示实时进度。 -->
    <div class="dispatch-progress" v-if="submitting || progress.total">
      <p>{{ $t('message.serviceDispatchProgress') }}：{{ progress.current }}/{{ progress.total }}</p>
      <el-progress :percentage="progressPercentage" />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button :disabled="submitting" @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">{{ $t('message.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 机器操作人不在普通可选人员接口中，按业务要求固定补充并置顶。
const MECHANICAL_OPERATOR = {
  id: 1377,
  username: 'P209',
  realname: '机器操作员',
  forbid_login: 0,
}

export default {
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      adminId: '',
      adminList: [],
      serviceOrders: [],
      progress: {
        current: 0,
        total: 0,
        failed: 0,
      },
    }
  },
  computed: {
    progressPercentage() {
      if (!this.progress.total) return 0
      return Math.round(this.progress.current / this.progress.total * 100)
    },
  },
  methods: {
    // 父页面传入已勾选的服务单，组件统一加载可调配人员。
    open(serviceOrders) {
      this.serviceOrders = [...serviceOrders]
      this.adminId = ''
      this.progress = { current: 0, total: 0, failed: 0 }
      this.dialogVisible = true
      this.loadAdminList()
    },
    loadAdminList() {
      this.$api.optionServiceApi.usableAdminList().then(res => {
        this.adminList = [
          MECHANICAL_OPERATOR,
          ...res.data.filter(item => item.id != MECHANICAL_OPERATOR.id),
        ]
      })
    },
    async submit() {
      if (!this.adminId) return this.$message.warning(this.$t('message.personnelSelection'))

      this.submitting = true
      this.progress = {
        current: 0,
        total: this.serviceOrders.length,
        failed: 0,
      }

      // 后端仅提供单服务单调配接口；任意一单失败后立即停止，不再处理后续服务单。
      for (const item of this.serviceOrders) {
        let isFailed = false
        try {
          const res = await this.$api.optionServiceApi.updateAdminId({
            service_sn: item.service_sn,
            adminId: this.adminId,
          }, {
            isLoading: true, // 批量时关闭全屏 Loading，避免遮挡组件内进度条。
            resolveError: true, // 失败响应也结束当前 Promise，以便立即停止批量处理。
          })
          isFailed = res.code != 0
        } catch (error) {
          isFailed = true
        } finally {
          this.progress.current += 1
        }

        if (isFailed) {
          this.progress.failed += 1
          break
        }
      }

      this.submitting = false
      this.dialogVisible = false
      if (this.progress.failed) {
        this.$message.warning(this.$t('message.serviceDispatchFailedCount', { count: this.progress.failed }))
      } else {
        this.$message.success(this.$t('message.serviceDispatchSuccess'))
      }
      // 全部成功时在最后一单完成后刷新；失败时停止后续任务并立即刷新。
      this.$emit('refresh')
    },
  },
}
</script>

<style lang="scss" scoped>
.admin-select {
  display: flex;
  align-items: center;
  padding: 0 30px;

  span {
    width: 100px;
  }

  .el-select {
    flex: 1;
  }
}

.dispatch-progress {
  margin-top: 24px;
  padding: 0 30px;

  p {
    margin-bottom: 10px;
  }
}
</style>
